<template>
  <div class="user-account">
    <div class="card-box">
      <div class="card-box_content">
        <GwMessage
          :message="{
            hide: true,
            icon: 'mdi-earth',
            type: 'error',
            text: $t('messages.translators_wanted'),
          }"
          style="--clr-back: #23b5ef"
          class="mb-4"
        >
          <template #default>
            <span>
              {{ $t('messages.translators_wanted') }}
              <br />
              {{ $t('messages.help_us_localize') }}
              <br />
              {{
                $t('messages.contact_team_member', {
                  team_member: '@GTOWizard Pedro',
                })
              }}
              <a
                :href="links_url_links.discord_invite_link.url"
                target="_blank"
                class="link-underline clr-primary"
                v-html="'Discord'"
              />.
            </span>
          </template>
        </GwMessage>

        <LangSwitcher asBlocks />
      </div>
    </div>
  </div>
</template>

<script>
import LangSwitcher from '@/components/LangSwitcher/LangSwitcher'
import GwMessage from '@/components/Messages/GwMessage'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'UserLanguage',

  components: {
    LangSwitcher,
    GwMessage,
  },
  mixins: [links_mix],
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
@media (max-width: 1023px) {
  .card-box {
    flex-direction: column;
    &_title {
      margin-bottom: 1rem;
    }
  }
}
.user-account {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.card-box {
  display: flex;
  max-width: 960px;
  border-radius: 4px;
  flex-shrink: 0;

  &_title {
    min-width: 12rem;
  }
  &_content {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding-bottom: 2rem;
  }
  &_text {
    position: relative;
    border-radius: 4px;
  }
}

.tier-tag {
  border-radius: 4px;
  font-weight: 700;
  font-size: 1.25rem;
  flex: 0;
  &_trial {
    color: var(--clr-white-0);
  }
  &_starter {
    color: var(--clr-blue);
  }
  &_premium {
    color: var(--clr-yellow);
  }
  &_icon {
    font-size: 1.5rem;
    margin: 0 0.5rem 0 0;
    color: currentColor;
  }
}
.discord-box {
  max-width: 32rem;
}

.img-container {
  img {
    border-radius: 8px;
    max-width: 90vw;
  }
}
</style>
